<template>
  <v-tabs
    icons-and-text
    background-color="white"
    dense
    tile
    flat
    v-if="tabs && tabs.length > 0"
    v-bind="$attrs"
  >
    <v-tabs-slider></v-tabs-slider>
    <v-tab
      v-for="tab in tabs"
      :key="tab.name"
      :active_tab="tab.name === selected.name"
      @change="updateSelectedTab(tab)"
      v-bind="tabProperties(tab)"
    >
      {{ tab.name }}
      <v-icon>{{ tab.icon }}</v-icon>
    </v-tab>
    <slot />
  </v-tabs>
</template>
<script>
export default {
  props: {
    defaultSelectedIndex: {
      default: 0,
      type: Number,
    },
    tabs: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      selected: this.tabs[this.defaultSelectedIndex] || {},
    };
  },
  methods: {
    updateSelectedTab(tab) {
      this.selected = tab;
      this.$emit("selected", tab);
    },
    tabProperties(tab) {
      /*eslint-disable-next-line */
      const { name, value, icon, ...otherProps } = tab;
      return otherProps;
    },
  },
};
</script>
